module.exports = __webpack_public_path__ + "40db7029addcb8fed94be78e23acb47f.svg";